import { Link } from 'react-router-dom'
import { LandingSection } from './LandingSection'

export function LandingWhy() {
  return (
    <LandingSection
      id="why-pingscalate"
      title="Monitoring that works behind Cloudflare and strict filters"
      subtitle="Many uptime tools get blocked by WAF rules. Pingscalate is built for real-world checks."
    >
      <div className="max-w-3xl space-y-4 text-base leading-relaxed text-text-secondary">
        <p>
          Basic uptime checkers often fail against Cloudflare, bot protection, and API gateways—not
          because your site is down, but because the check looks like a bot. That means false
          alarms or missed outages.
        </p>
        <p>
          Pingscalate lets you send browser-like user agents, custom headers, and POST payloads so
          checks behave like real traffic. Combine that with Slack and email alerts, public status
          pages, and escalation policies your team controls, and you get signal—not noise.
        </p>
        <p>
          <Link to="/uptime-monitoring" className="text-accent hover:underline">
            Uptime monitoring
          </Link>
          {' · '}
          <Link to="/slack-uptime-alerts" className="text-accent hover:underline">
            Slack alerts
          </Link>
          {' · '}
          <Link to="/email-uptime-alerts" className="text-accent hover:underline">
            Email alerts
          </Link>
          {' · '}
          <Link to="/public-status-pages" className="text-accent hover:underline">
            Public status pages
          </Link>
          {' · '}
          <Link to="/ssl-domain-monitoring" className="text-accent hover:underline">
            SSL & domain monitoring
          </Link>
          {' · '}
          <Link to="/alternatives" className="text-accent hover:underline">
            Compare alternatives
          </Link>
        </p>
      </div>
    </LandingSection>
  )
}
